/* Color palette */

export const primaryColor = {
    backgroundColor: '#137cbd'
};

export const secondaryColor = {
    backgroundColor: 'rgb(19, 124, 189)'
};


/* Font styles */

export const fontWeightNormal = {
    fontWeight: 'normal'
};

export const fontItalic = {
    fontStyle: 'italic'
};

export const fontWeightBold = {
    fontWeight: 'bold'
};

export const fontNormalBold = {
    fontStyle: 'normal',
    fontWeight: 'bold'
};


/* Flex properties */

export const flexCenter = {
    display: 'flex',
    alignItems: 'center',
};

export const flexColumn = {
    display: 'flex',
    flexDirection: 'column'
};

export const flexRowCenter = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};

export const displayFlex = {
    display: 'flex'
};

export const flexRow = {
    display: 'flex',
    flexDirection: 'row'
};

export const inlineFlex = {
    display: 'inline-flex'
};


/* General styles */

export const permissionContainer = {
    height: '10em',
    margin: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
}

export const textAlignCenter = {
    textAlign: 'center'
};

export const tripsHeaderSubcontainer = (useDarkTheme) => {
    return({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: '2',
        position: 'sticky',
        top: '50px',
        padding: '1em',
        backgroundColor: useDarkTheme? '#30404D':'#FFFFFF'})
};

export const providerSpanStyle = {
    display: 'block',
    marginTop: '0.5em'
};

export const preferredProviderContainer = {
    flexDirection: 'row',
    display: 'flex',
    width: '170%'
};

export const tripsHeaderContainer = {
    width: '100%',
    margin: '1em',
    marginBottom: '0px',
    marginTop: '0px'
};

export const servicePanelContainer = {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1em',
    marginTop: '1em'
};

export const statesFiltersContainer = {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content',
    paddingLeft: '7px'
};

export const labelContainer = {
    marginBottom: '1em',
    color: '#FAFAFA'
}

export const houstonIconStyle = {
    width: '35px',
    paddingRight: '1%',
    paddingLeft: '1%'
};

export const arrowsIconTable = {
    float: 'right',
    width: '5%'
};

export const popoverContainerDiv = {
    display: 'flex',
    paddingLeft: '30px'
};

export const serviceLevelDiv = {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content',
    paddingLeft: '5%'
};

export const specialtyDiv = {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content',
    paddingLeft: '5%'
};

export const dateTimeDiv = {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content',
    paddingLeft: '5%'
};

export const filterButtonMainDiv = {
    paddingTop: '10%',
    paddingBottom: '1%',
    paddingRight: '12px',
    display: 'flex',
    justifyContent: 'flex-end'
};

export const filterModalMenu = {
    maxHeight: 'none',
    overflow: 'unset',
    padding: '4px 10px 4px 10px',
    display: 'flex',
    flexDirection: 'column',
    width: '63em'
};

export const timeButtonsContainer = {
    width: "auto",
    display: "grid",
    paddingTop: "2em",
};

export const todayButtonStyle = {
    marginBottom : "1em"
};

export const clearDateTimeButtonStyle = {    
    padding: "0 0 0 0",
    minHeight: "1.7em"
};

export const clientsFiltersContainer = {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content',
    paddingLeft: '5%'
};

export const levelsFiltersContainer = {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content',
    paddingLeft: '5%'
};

export const specialtyFiltersContainer = {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content'
};

export const dateTimeFiltersContainer = {
    width: 'fit-content',
    display: 'flex'
};

export const timeFilterInput = {
    outline: 'none',
    border: '1px solid rgba(118, 118, 118, 0.3)',
    color: '#545454',
    textAlign: 'center',
    backgroundColor: 'lightgrey',
    marginRight: "0.5em",
    marginLeft:"0.5em"
};

export const justifyCenter = {
    justifyContent: 'center'
};

export const backToTopButton = {
    justifyContent: 'center',
    position: 'fixed',
    bottom: 10,
    cursor: 'pointer',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'linear',
    transitionDelay: '0s',
    borderRadius: '20px'
}

export const filterButton = {
    cursor: 'pointer',
    borderRadius: '20px'
}

export const cancelButtonStyle = {
    backgroundColor: 'lightgrey',
    backgroundImage: 'none',
    color: '#394b59'
};

export const anchorButtonStyle = {
    backgroundColor: 'lightgreen',
    color: '#394b59'
};

export const requiredMessage = {
    color: "#FA1011",
    fontWeight: "bold"
};

export const dialogFooter = {
    flexDirection: 'row',
    alignItems: 'flex-end'
};

export const tdPadding = {
    padding: '5px'
};

export const tdPaxFirstName = {
    padding: '5px',
    display: 'table-cell',
    flexDirection: 'row'
};

export const footerActions = {
    display: 'flex',
    justifyContent: 'space-between'
};

export const verticalAlignMiddle = {
    verticalAlign: 'middle'
};

export const completeHeightWeight = {
    height: '100%',
    width: '100%'
};

export const completeWidth = {
    width: '100%'
};

export const displayBlock = {
    display: 'block'
};

export const checkboxMargin = {
    margin: '0 0 0 1.5em'
};

export const filterButtonContainer = {
    justifyContent: 'center',
    paddingBottom: '2%',
    paddingTop: '2%',
    paddingLeft: '10%'
};

export const clearButtonContainer = {
    justifyContent: 'center',
    paddingBottom: '2%',
    paddingTop: '2%',
    paddingLeft: '10px',
    width: 'max-content'
};

export const buttonMap = {
    width: '100%',
    height: '70%',
    backgroundColor: '#00000014',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

export const mapHeaderContainer = {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginBottom: '0.5em',
    fontSize: '90%',
    height: '5%'
};

export const mapFooterContainer = {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginTop: '0.7em',
    height: '8%'
};

/* HeaderComponent Styles */

export const headerComponentStyle = {
    position: 'sticky', 
    top: 0
};

/* ExceptionsContainer Styles */

export const exceptionsDetailsField = {
    width: '30%',
    padding: '5px'
};

export const footerButtonsContainer = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
};

export const gurneyIcon = {
    width: '18px',
    paddingRight: '1px'
};

export const exceptionsMainContainer = {
    display: 'flex',
    width: 'auto',
    alignItems: 'flex-start'
};

export const exceptionsSubContainer = {
    width: '100%',
    margin: '1em',
    marginBottom: '0px',
    marginTop: '0px'
};

export const stateCheckbox = {
    fontWeight: 'bold',
    width: 'max-content'
};

export const filterPopoverSubtitle = {
    justifyContent: 'center',
    display: 'flex'
};

export const mapContainer = {
    width: '100%',
    height: '80%',
    backgroundColor: '#00000014',
    display: 'flex'
};

export const popoverSettings = {
    padding: '5px',
    display: 'flex',
    width: 'auto'
};

export const exceptionsFontStyle = {
    fontSize: '1.2em',
    fontWeight: 'bold'
};

export const serviceAreaButton = {
    flexDirection: 'row-reverse',
    paddingLeft: '23px'
};

export const exceptionsHeaderContainer = (useDarkTheme) => {
    return({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: '2',
        position: 'sticky',
        top: '50px',
        padding: '1em',
        backgroundColor: useDarkTheme? '#30404D':'#FFFFFF' })
};


/* exceptionsTable Styles */

export const exceptionsTableStyles = {
    width: '100%',
    borderRadius: '.2em',
    boxShadow: '0px 0px 2px #111',
    backgroundColor: '#00000021',
    fontSize: '90%',
    position: 'relative'
};

export const tablePopoverColors = {
    color: 'black',
    backgroundColor: 'white',
    width: 'auto'
};


/* headerComponent Styles */

export const adminMenuDivider = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '0px'
};

export const menuMargin = {
    margin: 10,
    marginBottom: 0,
};

export const menuMarginAdmin = {
    margin: 10,
    marginBottom: 0,
    width: '-webkit-fill-available',
};

export const eventHeader = {
    justifyContent: 'center',
    display: 'flex',
}

export const menuSwitch = {
    marginLeft: 7,
    marginTop: 10
};


/* tripDetailComponent Styles */

export const rightPanelSpinnerContainer = {
    backgroundColor: 'rgb(48, 64, 77)',
    display: 'contents'
};

export const rightPanelSpinnerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '120px'
};

export const willCallContainer = {
    display: 'flex',
    justifyContent: 'space-between',
    height: '6%'
};


/* tripDetailTabPanel Styles */

export const pickUpFlexContainer = {
    width: '90%',
    paddingRight: '10px'
};

export const tripDetailsFlexDiv = {
    display: 'flex',
    width: '44%'
};

export const keyEventsSpinnerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '40%',
};

export const keyEventsSpinnerContainer = {
    backgroundColor: 'rgb(60, 22, 11)',
    display: 'contents'
};

export const clientIcon = {
    paddingRight: '0.25em'
};

export const purposeSpan = {
    paddingLeft: '75px'
};

export const tripDetailPanelDivFull = {
    marginTop: '10px',
    height: 'max-content'
}

export const pickUpIcon = {
    fontSize: '1.2em',
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '0.5em'
};

export const phoneIcon = {
    display: 'block',
    marginTop: '0.5em',
    fontStyle: 'italic'
};

export const phoneIconWidth = {
    width: '1.5em'
};

export const mobilePhoneIconWidth = {
    width: '1.5em'
};

export const dropOffIcon = {
    fontSize: '1.2em',
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '0.5em'
};

export const calendarCheckIcon = {
    fontSize: '1.2em',
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '0.5em'
};

export const widthAuto = {
    width: 'auto'
};

export const clientPanelWidth = {
    width: 'auto',
    paddingTop: '5%'
};

export const tspSpanWidth = {
    display: 'block',
    width: '170%'
};

export const servicePanelWidth = {
    width: '57%',
    display: 'flex',
    flexDirection: 'column'
};

export const mainSpanStyle = {
    fontSize: '1.2em',
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '0.5em'
};

export const serviceAndPaxContainer = {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1em',
    marginTop: '1em'
};

export const pickUpDropOffContainer = {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1em'
};

export const keyEventsTable = {
    borderCollapse: "collapse",
    borderStyle: 'hidden',
    width: '100%',
    borderRadius: '.2em',
    boxShadow: '0px 0px 2px #111',
    backgroundColor: '#00000021'
};

export const tripDetailTableDiv = {
    display: 'flex',
    marginTop: '1.5em',
    flexDirection: 'column',
    marginBottom: '1.5em'
}

export const tripMilesSpan = {
    display: 'block',
    marginTop: '0.5em'
};

export const tripDetailsColumnContainer = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1em',
    marginTop: '1em'
};

export const clientInfoContainer = {
    width: 'auto',
    paddingTop: '5%'
};

export const totalPaySpan = {
    display: 'block',
    marginTop: '1em'
};

export const blockSpan = {
    display: 'block',
    marginTop: '1em'
};

export const boltTripIdSpan = {
    display: 'block',
    marginTop: '0.7em'
};

export const collectSpan = {
    display: 'block',
    marginTop: '1em'
};

export const mobilePhoneIconSpan = {
    display: 'block',
    marginTop: '0.5em',
    fontStyle: 'italic'
};


/* dialogNonParComplete Styles */

export const providerNameInput = {
    textAlign: 'center',
    width: '100%'
};

export const inputSettings = {
    width: '100%',
    textAlign: 'center',
    outline: 'none',
    border: 'none',
    borderRadius: '3px',
    boxShadow: '0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2)',
    background: '#ffffff',
    height: '30px',
    padding: '0 10px',
    verticalAlign: 'middle',
    lineHeight: '30px',
    color: '#182026',
    fontSize: '14px',
    fontWeight: '400',
    transition: 'box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9)',
    webkitAppearance: 'none'
};

export const providerNumberContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
};

export const tripPriceInput = {
    width: '100%',
    textAlign: 'center',
    outline: 'none',
    border: 'none',
    borderRadius: '3px',
    boxShadow: '0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2)',
    background: '#ffffff',
    height: '30px',
    padding: '0 10px',
    verticalAlign: 'middle',
    lineHeight: '30px',
    color: '#182026',
    fontSize: '14px',
    fontWeight: '400',
    transition: 'box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9)',
    webkitAppearance: 'none'
};

export const tripPriceDiv = {
    paddingLeft: '2%',
    width: '30%'
};

export const phoneNumberDiv = {
    width: '45%'
};

export const tripPriceContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
};

export const nonParGeneralStyles = {
    backgroundColor: 'white',
    width: 'auto%'
};

export const nonParDialogBody = {
    paddingRight: '6%',
    paddingLeft: '6%',
    flexDirection: 'column'
}

export const providerNumberDiv = {
    paddingTop: '8px',
    width: 'auto'
};

export const labelSettings = {
    color: '#394b59'
};


/* OverlayWaitTime Styles */

export const waitTimeMinutesTitle = {
    fontStyle: 'italic',
    fontWeight: 'normal'
};

export const waitTimeSaveButton = {
    marginRight: '10px'
};

export const textareaPadding = {
    paddingTop: '5px'
};

export const textareaContainer = {
    marginBottom: '1em'
};

export const waitTimeSubcontainer = {
    padding: '2% 4% 2% 4%'
};

export const waitTimeNotesArea = {
    backgroundColor: '#FAFAFA',
    color: 'rgb(57, 75, 89)',
    height: '90px',
    textAlign: 'start',
    outline: 'none',
    border: 'none',
    borderRadius: '3px',
    boxShadow: '0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2)',
    verticalAlign: 'middle',
    lineHeight: '30px',
    fontSize: '14px',
    fontWeight: '400',
    transition: 'box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9)',
    webkitAppearance: 'none'
};

export const waitTimeTitleInput = {
    display: 'flex',
    flexDirection: 'row',
    paddingRight: '10px',
    paddingTop: '6px'
}

export const waitTimeNumberInput = {
    width: '30%',
    textAlign: 'center',
    outline: 'none',
    border: 'none',
    borderRadius: '3px',
    boxShadow: '0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2)',
    backgroundColor: '#FAFAFA',
    height: '30px',
    verticalAlign: 'middle',
    lineHeight: '30px',
    color: 'rgb(57, 75, 89)',
    fontSize: '14px',
    fontWeight: '400',
    transition: 'box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9)',
    webkitAppearance: 'none'
};


/* overlayWillcall Styles */

export const overlayWillcallContainer = {
    top: '20%',
    left: 'calc(50vw - 250px)',
    margin: '10vh 0',
    width: '23%',
    height: 'auto'
};

export const overlayWillcallTitle = {
    paddingTop: '15px',
    textAlign: 'center'
};

export const willcallSaveButton = {
    marginRight: '10px'
};

export const willcallCancelButton = {
    marginRight: '10px'
};

export const footerOverlayWillcall = {
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'center'
};


/* overlayCancelTrip Styles */

export const overlayCancelTripContainer = {
    top: '20%',
    left: 'calc(50vw - 250px)',
    margin: '10vh 0',
    height: 'auto'
};

export const cancelTripTitle = {
    paddingTop: '15px'
};

export const trashIconStyle = {
    marginRight: '20px'
};

export const cancelTripSaveButton = {
    marginRight: '10px'
};

export const footerCancelTrip = {
    paddingTop: '10px',
    paddingRight: '3%',
    display: 'flex',
    justifyContent: 'flex-end'
};


/* overlayConfirmProvider Styles */

export const overlayConfirmProviderContainer = {
    top: '20%',
    left: 'calc(50vw - 250px)',
    margin: '10vh 0',
    width: '25%',
    height: 'auto'
};

export const providerContainer = {
    paddingTop: '20px',
    display: 'flex'
};

export const confirmProviderSaveButton = {
    marginRight: '10px'
};

export const overlayFooterConfirmProvider = {
    paddingTop: '10px',
    paddingRight: '3%',
    display: 'flex',
    justifyContent: 'flex-end'
};


/* tripStatusFilterModal Styles */

export const checkboxesContainerDiv = {
    width: '210px'
};

export const minimalistFilterButton = {
    marginRight: '20px',
    width: '40px'
};


/* providersContainer Styles */

export const tripStatusMenuTag = {
    maxHeight: 'none',
    overflow: 'unset',
    padding: '0px 0px 5px 10px'
};

export const exportFileButton = {
    width: '42px'
};

export const csvLinkContainer = {
    paddingRight: '15px',
    paddingTop: '1px'
};


/* dialogConfirmProvider Styles */

export const requiredColor = {
    color: "#FA1011",
    paddingLeft: '1%',
    fontWeight: 'bold'
};

export const labelDriver = {
    marginBottom: '1em',
    color: '#394b59'
};

export const driverPadding = {
    paddingTop: '20px'
};


/* overlayEmulateEvents Styles */

export const overlayDivContainer = {
    top: '20%',
    left: 'calc(50vw - 250px)',
    margin: '10vh 0',
    width: 'auto',
    height: 'auto'
};

export const overlayFooterContainer = {
    paddingTop: '10px'
};

export const emulateMainGrid = {
    display: 'grid',
    gridTemplateColumns: 'auto'
};

export const emulateEventsMainRow = {
    textAlign: 'right',
    justifyContent: 'right',
    display: 'grid',
    gridTemplateColumns: '30% 70%'
};

export const timeZoneAlign = {
    textAlign: 'center',
    paddingTop: '10px',
    paddingBottom: '10px'
};

export const emulateInputStyle = {
    marginLeft: '5px',
    padding: '10px',
    display: 'flex'
};

export const labelDbSavedStyle = {
    marginLeft: '5px',
    padding: '11px',
    display: 'flex',
    alignItems: 'center'
}

export const emulateEventsInput = {
    outline: 'none',
    border: '1px solid darkslategrey',
    textAlign: 'center',
    backgroundColor: 'lightgrey'
};

export const emulateDialogLabel = {
    paddingLeft: '3px'
};

export const emulateDialogSubtitle = {
    padding: '12px',
    textAlign: 'right'
};


/* loadingSpinner Styles */

export const loadingSpinnerContainer = {
    backgroundColor: 'rgb(48, 64, 77)',
    display: 'contents'
};

export const loadingSpinnerStyle = {
    paddingBottom: '15%'
};

/* lateTripsContainer Styles */

export const lateTripsContainer = {
    display: 'flex',
    alignItems: 'flex-start',
    width: 'auto'
};

/* openTripsContainer Styles */

export const openTripsContainer = {
    display: 'flex',
    alignItems: 'flex-start',
    width: 'auto'
};

export const asOfSpan = {
    fontSize: '1em',
    display: 'block'
};

export const tabSpanMargin = {
    marginTop: '1em'
};

export const spanSetting = {
    fontSize: '1em',
    display: 'block',
    maxWidth: '170px'
};

export const mapContainerSetting = {
    width: '100%',
    height: '70% !important',
    backgroundColor: '#00000014',
    display: 'flex'
};

export const openTripsHeaderContainer = {
    width: '100%',
    margin: '1em',
    marginBottom: '0px',
    marginTop: '0px'
};

export const tripsSpan = {
    fontSize: '1.2em',
    fontWeight: 'bold'
};

export const openTripsHeaderSubcontainer = (useDarkTheme) => {
    return({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: '2',
        position: 'sticky',
        top: '50px',
        padding: '1em',
        backgroundColor: useDarkTheme? '#30404D':'#FFFFFF' })
};

export const refreshButtonContainer = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #000',
    borderRadius: '4px',
    paddingRight: '5px'

};

export const tripsIcons = {
    fontSize: '1.2em',
    display: 'block'
};

export const rightColumnMainDiv = {
    margin: '1em',
    marginRight: '2em',
    width: '35em',
    height: '100%',
    fontSize: '90%',
    position: 'sticky',
    top: '10px',
    bottom: '10px'
};

export const tripDetailPanelDiv = {
    marginTop: '10px',
};


/* openTripsTable Styles */

export const openTripsTablePopover = {
    color: 'black',
    backgroundColor: 'white'
};

export const htmlTableStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '.2em',
    boxShadow: '0px 0px 2px #111',
    backgroundColor: '#00000021',
    fontSize: '90%',
    position: 'relative'
};

export const htmlHeaderStyle = (useDarkTheme) => {
    return({
        position: 'sticky',
        top:'109px',
        backgroundColor: useDarkTheme? '#2A3843':'#DEDEDE',
        boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)'})
};

/* tripNotesPanel Styles */

export const notesArea = {
    backgroundColor: '#F5F5F5',
    color: '#1d1d1d',
    height: '150px',
    fontSize: 'small'
};

export const notesMainContainer = {
    paddingLeft: '5%',
    paddingRight: '5%',
    overflow: 'auto',
    height: '210px'
};

export const notesMainContainerFull = {
    paddingLeft: '5%',
    paddingRight: '5%',
};


export const marginNotesScroll = {
    marginRight: '2%',
    marginBottom: '5%'
};

/* Providers Container Styles */

export const providerTripsContainer = {
    display: 'flex',
    alignItems: 'flex-start',
    width: 'auto',
    height: 'auto'
};

export const datesTitleStyle = {
    paddingLeft: '22px',
    paddingRight: '10px',
    paddingTop: '7px',
    width: '50%'
};

export const firstLabelStyle = {
    paddingRight: '10px',
    paddingTop: '7px',
};

export const labelStyle = {
    paddingLeft: '22px',
    paddingRight: '10px',
    paddingTop: '7px',
};

export const labelStyleFitContent = {
    paddingLeft: '22px',
    paddingRight: '10px',
    paddingTop: '7px',
    minInlineSize: 'max-content'
};

export const filterStyle = {
    paddingLeft: '22px',
    paddingRight: '10px',
};

export const providerTitleStyle = {
    paddingTop: '6px'
};

export const suggestContainer = {
    paddingRight: '20px',
    paddingTop: '1px'
};

export const suggestProviderComponentStyle = {
    borderRight: '10px',
};

export const searchButtonWidth = {
    width: '100px'
};

export const dateRangePickerContainer = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: '20px'
};

export const dateRangePickerContainerAdvanced = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};

export const providerHtmlHeaderStyle = (useDarkTheme) => {
    return({
        position: 'sticky',
        top:'116px',
        backgroundColor: useDarkTheme? '#2A3843':'#DEDEDE',
        boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)'})
};

/* Trip Search Container Styles */

export const tripSearchContainer = {
    display: 'flex',
    alignItems: 'flex-start',
    width: 'auto'
};

export const tripSearchHeaderContainer = {
    width: '100%',
    margin: '0px 1em 0px'
};

export const tripSearchHeaderSubcontainer = (useDarkTheme) => {
    return({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: '2',
        position: 'sticky',
        top: '50px',
        padding: '1em',
        backgroundColor: useDarkTheme? '#30404D':'#FFFFFF' })
};

export const advancedFilters =  (useDarkTheme) => {
    return({
        // display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        zIndex: '2',
        position: 'sticky',
        top: '113px',
        padding: '0em 1em 1em',
        backgroundColor: useDarkTheme? '#30404D':'#FFFFFF' })
};

export const tripSearchHtmlHeaderStyle = (useDarkTheme, showAdditionalFilters) => {
    return({
        position: 'sticky',
        top: showAdditionalFilters ? '206px' :'113px',
        backgroundColor: useDarkTheme? '#2A3843':'#DEDEDE',
        boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)'})
};

export const showAdditionalFilters = {
    paddingLeft: '2rem'
};

export const statusDropdown = {
    outline: 'none',
    border: 'none',
    borderRadius: '3px',
    boxShadow: '0 0 0 0 rgb(19 124 189 / 0%), 0 0 0 0 rgb(19 124 189 / 0%), inset 0 0 0 1px rgb(16 22 26 / 15%), inset 0 1px 1px rgb(16 22 26 / 20%)',
    background: '#ffffff',
    height: '30px',
    padding: '0 10px',
    verticalAlign: 'middle',
    lineHeight: '30px',
    color: '#182026',
    fontSize: '14px',
    fontWeight: '400',
    transition: 'box - shadow 100ms cubic - bezier(0.4, 1, 0.75, 0.9)',
    appearance: 'none'
};

export const linkButton = {
    alignItems: 'normal',
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: 'rgb(0, 0, 238)',
    borderStyle: 'none',
    boxSizing: 'content-box',
    color: '#106ba3',
    cursor: 'pointer',
    display: 'inline',
    font: 'inherit',
    height: 'auto',
    padding: '0',
    perspectiveOrigin: '0 0',
    textAlign: 'start',
    transformOrigin: '0 0',
    width: 'auto',
}

/* DateRangePickerComponent Styles */

export const dateRangePickerButton = {
    width: '320px',
    outline: 'none',
    border: 'none',
    borderRadius: '3px',
    boxShadow: '0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2)'
};

export const hotkeyMessage = {
    paddingTop: '16%',
    paddingLeft: '2%',
    color: "#645f5f"
};

export const editActions = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
}

export const editButtons = {
    marginBottom: '3%',
    marginRight: '10px'
}
